export default {
    "modal": {
        "buttons": {
            "ok": "OK",
            "cancel": "Abbrechen",
            "yes": "Ja",
            "no": "Nein",
            "abort": "Abbrechen",
            "retry": "Wiederholen",
            "ignore": "Ignorieren"
        },

        "confirm": {
            "title": "Bestätigen"
        },
        "prompt": {
            "title": "Geben Sie einen Wert ein"
        }
    }
};
